
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { supabase } from "@/integrations/supabase/client";
import { toast } from "@/hooks/use-toast";

export const useRemoveUserFromGym = () => {
  const queryClient = useQueryClient();

return useMutation({
    mutationFn: async ({ 
      userId, 
      gymId, 
      isPending = false 
    }: { 
      userId: string; 
      gymId: string; 
      isPending?: boolean;
    }) => {
      console.log("Removing user from gym:", { userId, gymId, isPending });
      
      // Si es un pending member, eliminarlo directamente
      if (isPending) {
        const { error: deleteError } = await supabase
          .from("pending_members")
          .delete()
          .eq("id", userId)
          .eq("gym_id", gymId);

        if (deleteError) {
          console.error("Error deleting pending member:", deleteError);
          throw deleteError;
        }
        return; // Terminar aquí para pending members
      }

      // Flujo normal para usuarios registrados
      // Desactivar la membresía del usuario en el gimnasio
      const { error: membershipError } = await supabase
        .from("user_gym_memberships")
        .update({ is_active: false })
        .eq("user_id", userId)
        .eq("gym_id", gymId);

      if (membershipError) {
        console.error("Error deactivating membership:", membershipError);
        throw membershipError;
      }

      // Si el gym_id en profiles coincide con el gimnasio del que se está sacando, limpiarlo
      const { data: profileData, error: profileError } = await supabase
        .from("profiles")
        .select("gym_id")
        .eq("id", userId)
        .maybeSingle();

      if (profileError) {
        console.error("Error fetching profile:", profileError);
        throw profileError;
      }

      if (profileData?.gym_id === gymId) {
        const { error: updateError } = await supabase
          .from("profiles")
          .update({ gym_id: null })
          .eq("id", userId);

        if (updateError) {
          console.error("Error updating profile gym_id:", updateError);
          throw updateError;
        }
      }
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["users"] });
      toast({
        title: "Usuario removido del gimnasio",
        description: "El usuario ha sido removido del gimnasio correctamente.",
      });
    },
    onError: (error) => {
      console.error("Error removing user from gym:", error);
      toast({
        variant: "destructive",
        title: "Error",
        description: "No se pudo remover el usuario del gimnasio.",
      });
    },
  });
};
